import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import dashboardSaga from './dashboardSaga';
import partsSaga from './partsSaga';
import purchaseOrderSaga from './purchaseOrderSaga';
import { workOrderSaga } from './workOrderSaga';
import routeCardSaga from './routeCardSaga';
import packingListSaga from './packingListSaga';
import bomSaga from './bomSaga';
import productSaga from './productSaga';
import componentSaga from './componentSaga';
import ncrSaga from './ncrSaga';
import toolFixtureSaga from './toolFixtureSaga';
import { adminSaga } from './adminSaga';
import { operationsSaga } from './operationsSaga';
import { workInstructionsSaga } from './workInstructionsSaga';
import { operatorsSaga } from './operatorsSaga';
import { inputsSaga } from './inputsSaga';
import { sectionsSaga } from './sectionsSaga';
import { workflowSaga } from './workflowSaga';
import { accountSaga } from './accountSaga';
import { ncractionSaga } from './ncractionSaga';
import { ncsubtypeSaga } from './ncsubtypeSaga';
import { nctypeSaga } from './nctypeSaga';
import { statusSaga } from './statusSaga';
import { clientSaga } from './clientSaga';
import { uofmSaga } from './uofmSaga';
import { eventTypeSaga } from './eventTypeSaga';
import { machineSaga } from './machineSaga';
import { operationTypeSaga } from './operationTypeSaga';
import { shiftsSaga } from './shiftsSaga';
import { partAttributesSaga } from './partAttributesSaga';
import { partClassSaga } from './partClassSaga';
import { partSecAttributesSaga } from './partSecAttributesSaga';
import { partTercAttributesSaga } from './partTercAttributesSaga';
import { shipToSaga } from './shipToSaga';
import { toolTypeSaga } from './toolTypeSaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    dashboardSaga(),
    partsSaga(),
    purchaseOrderSaga(),
    workOrderSaga(),
    routeCardSaga(),
    packingListSaga(),
    bomSaga(),
    productSaga(),
    componentSaga(),
    ncrSaga(),
    toolFixtureSaga(),
    adminSaga(),
    operationsSaga(),
    workInstructionsSaga(),
    operatorsSaga(),
    inputsSaga(),
    sectionsSaga(),
    workflowSaga(),
    accountSaga(),
    ncractionSaga(),
    ncsubtypeSaga(),
    nctypeSaga(),
    statusSaga(),
    clientSaga(),
    uofmSaga(),
    eventTypeSaga(),
    machineSaga(),
    operationTypeSaga(),
    shiftsSaga(),
    partAttributesSaga(),
    partClassSaga(),
    partSecAttributesSaga(),
    partTercAttributesSaga(),
    shipToSaga(),
    toolTypeSaga(),
  ]);
} 